  let questions = document.querySelectorAll(".questions");

  questions.forEach(questions => {
    questions.addEventListener("click", event => {
      const active = document.querySelector(".questions.active");
      if (active && active !== questions) {
        active.classList.toggle("active");
        active.nextElementSibling.style.maxHeight = 0;
      }
      questions.classList.toggle("active");
      var answers = questions.nextElementSibling;
      if (questions.classList.contains("active")) {
        answers.style.maxHeight = answers.scrollHeight + "px";
      } else {
        answers.style.maxHeight = 0;
      }
    })
  })



let questionssub = document.querySelectorAll(".questionssub");
  questionssub.forEach(questionssub => {
    questionssub.addEventListener("click", event => {
      const active = document.querySelector(".questionssub.active");
      var newQHeight = document.querySelector(".questions.active").nextElementSibling;
      if (active && active !== questionssub) {
        active.classList.toggle("active");
        active.nextElementSibling.style.maxHeight = 0;
       
      }
      questionssub.classList.toggle("active");
      const answerssub = questionssub.nextElementSibling;
      if (questionssub.classList.contains("active")) {
        answerssub.style.maxHeight = answerssub.scrollHeight + "px";
        
      } else {
        answerssub.style.maxHeight = 0;
      }
      setTimeout(() => {
            
           newQHeight.style.maxHeight = newQHeight.scrollHeight + "px";
        }, 200);
    })
  })



let questionsgsub = document.querySelectorAll(".questionsgsub");
  questionsgsub.forEach(questionsgsub => {
    questionsgsub.addEventListener("click", event => {
      const active = document.querySelector(".questionsgsub.active");
      var newQHeight = document.querySelector(".questions.active").nextElementSibling;
      if (active && active !== questionsgsub) {
        active.classList.toggle("active");
        active.nextElementSibling.style.maxHeight = 0;
       
      }
      questionsgsub.classList.toggle("active");
      const answersgsub = questionsgsub.nextElementSibling;
      if (questionsgsub.classList.contains("active")) {
        answersgsub.style.maxHeight = answersgsub.scrollHeight + "px";
        
      } else {
        answersgsub.style.maxHeight = 0;
      }
      setTimeout(() => {
            
           newQHeight.style.maxHeight = newQHeight.scrollHeight + "px";
        }, 250);
    })
  })

























